// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var WarningSection__Jsx3 = require("../../uikit/reason/atoms/Sections/WarningSection__Jsx3.bs.js");

function UpgradePlanWarning__Jsx3$PlanWarning(props) {
  return JsxRuntime.jsxs(WarningSection__Jsx3.make, {
              children: [
                props.children,
                JsxRuntime.jsx(View__Jsx3.make, {
                      mt: "md",
                      children: Caml_option.some(JsxRuntime.jsx(ButtonsV5.Link.make, {
                                href: "/subscribe",
                                children: "Upgrade to Pro"
                              }))
                    })
              ]
            });
}

var PlanWarning = {
  make: UpgradePlanWarning__Jsx3$PlanWarning
};

function UpgradePlanWarning__Jsx3$PropertyDetails(props) {
  return JsxRuntime.jsxs(UpgradePlanWarning__Jsx3$PlanWarning, {
              children: [
                JsxRuntime.jsx(View__Jsx3.make, {
                      mb: "sm",
                      children: "Full property information is only available to Pro TAN Members:"
                    }),
                "If you want to learn more about any property, including the address, listing agent and other details, you need to upgrade to the Pro Plan."
              ]
            });
}

var PropertyDetails = {
  make: UpgradePlanWarning__Jsx3$PropertyDetails
};

var make = UpgradePlanWarning__Jsx3$PlanWarning;

exports.PlanWarning = PlanWarning;
exports.PropertyDetails = PropertyDetails;
exports.make = make;
/* ButtonsV5 Not a pure module */
